import auth from './auth/auth.module.js';
import devicesConnection from './devices-connection/devices-connection.module.js';

export default {
    auth,
    devicesConnection,
};
